import {
    CLEAR, CLEAR_FAILED, CLEAR_SUCCESSFUL, GET_OLD_RACES, GET_OLD_RACES_FAILED, GET_OLD_RACES_SUCCESSFUL,
    INIT_FAILED,
    INIT_SUCCESSFUL,
    INITIALIZE,
    SEARCH,
    SEARCH_FAILED,
    SEARCH_SUCCESSFUL, SET_AGENT,
    SET_MODAL, SET_POPUP, SET_SCROLL_FALSE, SET_SCROLL_TRUE
} from '../actions/types';
import moment from "moment";

const initialState = {
    initializing: true,
    activeRaces: [],
    oldRaces: [],
    loading: [],
    loadingOld: true,
    scrollable: true,
    princessAgent : false,
    openModal: () => {
    },
    openPopup: () => {
    }
}

const rootReducer = (state = initialState, action) => {
    switch (action.type) {

        case INITIALIZE: {
            return {...state, initializing: true}
        }
        case INIT_SUCCESSFUL: {
            action.payload.response.sort((a, b) => new Date(b.end.replace(/\s/, "T")) - new Date(a.end.replace(/\s/, "T")))
            return {
                ...state, activeRaces: action.payload.response.map(race => {
                    return {...race, searched: []}
                }), initializing: false
            }
        }
        case INIT_FAILED: {
            return {...state, initializing: false}
        }



        case GET_OLD_RACES: {
            return {...state, loadingOld: true}
        }
        case GET_OLD_RACES_SUCCESSFUL: {
            action.payload.response.sort((a, b) => new Date(b.end.replace(/\s/, "T")) - new Date(a.end.replace(/\s/, "T")))
            return {
                ...state, oldRaces: action.payload.response.map(race => {
                    return {...race, searched: []}
                }), loadingOld: false
            }
        }
        case GET_OLD_RACES_FAILED: {
            return {...state, loadingOld: false}
        }



        case SEARCH: {
            const aux = state
            aux.loading[action.payload.race] = true
            return {...state, ...aux}
        }
        case SEARCH_SUCCESSFUL: {
            const aux = state
            const index = action.payload.active ? aux.activeRaces.map(race => race.id).indexOf(action.payload.race) : aux.oldRaces.map(race => race.id).indexOf(action.payload.race)

            aux.loading[action.payload.race] = false
            action.payload.active && aux && aux.activeRaces && aux.activeRaces[index] && (aux.activeRaces[index].searched = action.payload.type === 'players' ? action.payload.results : [{
                date: moment().format('YYYY-MM-DD'),
                total: action.payload.results.length,
                items: action.payload.results
            }])
            !action.payload.active && aux && aux.oldRaces && aux.oldRaces[index] && (aux.oldRaces[index].searched = action.payload.type === 'players' ? action.payload.results : [{
                date: moment().format('YYYY-MM-DD'),
                total: action.payload.results.length,
                items: action.payload.results
            }])

            return {...state, ...aux}
        }
        case SEARCH_FAILED: {
            const aux = state
            aux.loading[action.payload.race] = false
            return {...state, ...aux}
        }



        case CLEAR: {
            const aux = state
            aux.loading[action.payload.race] = true
            return {...state, ...aux}
        }
        case CLEAR_SUCCESSFUL: {
            const aux = state
            const index = action.payload.active ? aux.activeRaces.map(race => race.id).indexOf(action.payload.race) : aux.oldRaces.map(race => race.id).indexOf(action.payload.race)

            aux.loading[action.payload.race] = false
            action.payload.active && aux && aux.activeRaces && aux.activeRaces[index] && (aux.activeRaces[index].searched = [])
            !action.payload.active && aux && aux.oldRaces && aux.oldRaces[index] && (aux.oldRaces[index].searched = [])

            return {...state, ...aux}
        }
        case CLEAR_FAILED: {
            const aux = state
            aux.loading[action.payload.race] = false
            return {...state, ...aux}
        }



        case SET_MODAL: {
            return {...state, openModal: action.payload}
        }
        case SET_SCROLL_TRUE: {
            return {...state, scrollable: true}
        }
        case SET_SCROLL_FALSE: {
            return {...state, scrollable: false}
        }



        case SET_POPUP: {
            return {...state, openPopup: action.payload}
        }



        case SET_AGENT: {
            return {...state, princessAgent: action.payload}
        }



        default: {
            return state
        }
    }
}

export {initialState, rootReducer}